var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrakeBianco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 140",
    role: "img",
    "aria-label": "STRAKE",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 311,
    y: 94,
    textAnchor: "middle",
    fontFamily: "'Helvetica Neue','Helvetica','Arial',sans-serif",
    fontWeight: 500,
    fontSize: 92,
    letterSpacing: 24,
    fill: "#FFFFFF"
  }, "STRAKE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrakeBianco);
export default __webpack_public_path__ + "static/media/strake-bianco.52c7ecc80328ae1f90b970440b183b63.svg";
export { ForwardRef as ReactComponent };